import { Box } from "@mui/material";
import { FinalCTA } from "./components/CTA/FinalCTA";
import MobileBottomBar from "./components/CTA/MobileBottomBar";
import Estimator from "./components/Estimator/Estimator";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import SampleCost from "./components/SampleCost/SampleCost";
import WhatWeEstimate from "./components/Scope/WhatWeEstimate";
import WhyCostlix from "./components/WhyCostlix/WhyCostlix";
import { Footer } from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Header />
      <MobileBottomBar />

      {/* Other sections */}
      <Box sx={{ pb: { xs: "96px", md: 0 } }}>
        <Hero />
        <Estimator />
        <WhyCostlix />
        <WhatWeEstimate />
        <SampleCost />
        <HowItWorks />
        <FinalCTA />
        <Footer />
      </Box>
    </>
  );
}

export default App;
